interface Props {
  problemas: readonly string[];
}

/** Tela mostrada quando `/config.js` falta ou está incompleto (CA-12). */
export function ErroDeConfiguracao({ problemas }: Props) {
  return (
    <main className="pagina-central">
      <h1>O painel não foi configurado corretamente</h1>
      <p>Avise o suporte técnico. Os itens abaixo estão faltando ou inválidos em /config.js:</p>
      <ul>
        {problemas.map((problema) => (
          <li key={problema}>
            <code>{problema}</code>
          </li>
        ))}
      </ul>
    </main>
  );
}
